export default __webpack_public_path__ + "3abe889578e3fbbe14eeb80ffee074da.jpeg";